/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable import/prefer-default-export */
import Collections from 'components/listings/collections/Collections/Collections'
import React, { useState } from 'react'

export function SaveToCollection({ listingId }) {
  const [showCollections, setShowCollections] = useState(false)

  return (
    <>
      <li className="list-inline-item">
        <span
          role="menu"
          className="listcollect"
          id={listingId}
          style={{ color: '#fff' }}
          onClick={() => setShowCollections(true)}
        >
          <i className="nookons-add mr-1" />
          Add to collection
        </span>
      </li>
      {showCollections && <Collections unitId={listingId} onClose={() => setShowCollections(false)} />}
    </>
  )
}
